package com.vamvisions.main.core.data.preferences

import com.vamvisions.main.core.domain.preferences.ColorScheme
import com.vamvisions.main.core.domain.preferences.Language
import com.vamvisions.main.core.domain.preferences.PreferencesRepository
import kotlinx.browser.localStorage

/**
 * Stores preferences in `localStorage`. Every access is guarded, because storage can be blocked or
 * throw; a failure only loses persistence.
 */
class LocalStoragePreferencesRepository : PreferencesRepository {

    override fun getColorScheme(): ColorScheme? =
        read(KEY_COLOR_SCHEME)?.let { value -> ColorScheme.entries.firstOrNull { it.name == value } }

    override fun setColorScheme(colorScheme: ColorScheme) = write(KEY_COLOR_SCHEME, colorScheme.name)

    override fun getLanguage(): Language? = read(KEY_LANGUAGE)?.let(Language::fromCode)

    override fun setLanguage(language: Language) = write(KEY_LANGUAGE, language.code)

    private fun read(key: String): String? = runCatching { localStorage.getItem(key) }.getOrNull()

    private fun write(key: String, value: String) {
        runCatching { localStorage.setItem(key, value) }
    }

    private companion object {
        const val KEY_COLOR_SCHEME = "vam.colorScheme"
        const val KEY_LANGUAGE = "vam.language"
    }
}
